/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { JsonType } from '../models/json-type';
export interface FormJsonDefinition {
  jsonType?: JsonType;
}

export class FormJsonDefinition {
  jsonType?: JsonType;

  constructor(value: FormJsonDefinition) {
    this.jsonType = value?.jsonType ? Object.entries(Object.values(JsonType)).flatMap((x) => x).find(x => x === value.jsonType) as JsonType : undefined;
  }
}
